type Indexable = {
  id: string | number;
};

export const deleteById = <T extends Indexable>(items: Array<T>, idToDelete: string | number) =>
  items.filter((item) => item.id !== idToDelete);

export const deleteByField = <T extends object, K extends keyof T>(items: Array<T>, field: K, value: T[K]) =>
  items.filter((item) => item[field] !== value);

export const updateFieldById = <T extends Indexable, V>(
  items: Array<T>,
  idToChange: string | number,
  fieldToChange: string,
  value: V
) => items.map((item) => (item.id === idToChange ? { ...item, [fieldToChange]: value } : item));
